import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import '../App.css';
import { formatPrice } from '../Utilities/Formats';

function ShippingTile({ id, name, isDefault, isSelected, shippingAddress, deliveryPrice, deliveryTime, deliveryDiscount, onClick, ...props }) {
  return (
    <div id={`shipping-tile-${id}`}  className={`row defaultBorderedItem clickArea ${isSelected ? 'selectedItem' : 'itemSelect'}`} onClick={onClick} style={{gap: '10px', justifyContent: 'space-between', alignItems: 'center', paddingTop: 'var(--mediumPadding)', paddingBottom: 'var(--mediumPadding)'}}>
      <div className='row' style={{alignItems: 'center', gap: '10px'}}>
        <span>{name}</span>
        {/* <span className='grayedText'>endereço selecionado: {shippingAddress}</span> */}
      </div>
      <div className='column' style={{alignItems: 'end', gap: '4px', whiteSpace: 'nowrap'}}>
        {!deliveryPrice || !deliveryTime
          ? <span>Grátis</span>
          :
          <>
            <span className='fontSize16'>
              {(() => {
                if (deliveryPrice === '0.00') {
                  return 'Grátis';
                }
                
                // Convert deliveryPrice from string to number and apply discount
                let price = parseFloat(deliveryPrice.replace(',', '.'));
                if (deliveryDiscount > 0) {
                  const discountedPrice = price - deliveryDiscount;
                  return (
                    <>
                      <span style={{textDecoration: 'line-through', color: 'var(--grayedText)'}}>R$ {deliveryPrice}</span> 
                      <span style={{fontWeight: 'bold'}}> {formatPrice(discountedPrice)} </span>
                      <span style={{backgroundColor: 'var(--highlightDarkGreen)', fontWeight: 'bold', color: 'var(--textColor)', padding: '2px 4px', borderRadius: '4px'}}>- {formatPrice(deliveryDiscount)}</span>
                    </>
                  );
                }
                
                return `R$ ${price.toFixed(2).replace('.', ',')}`;
              })()}
            </span>
            <span> {deliveryTime}
                {deliveryTime != '1'
                    ? ' dias úteis'
                    : ' dia útil'
                }
            </span>
          </>
        }
        {/* <span>{deliveryTime}
            {deliveryTime >= 1
                ? ' dias úteis'
                : ' dia útil'
            }
        </span> */}
      </div>
    </div>
  );
}

ShippingTile.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.node.isRequired,
  shippingAddress: PropTypes.string.isRequired, // Ensure this matches the prop being passed
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  deliveryPrice: PropTypes.string, // Optional if not always provided
  deliveryTime: PropTypes.string, // Optional if not always provided
  deliveryDiscount: PropTypes.number, // Optional if not always provided
};

export default ShippingTile;